<woa-qr-code [background]="'#DDD'" [foreground]="'#444'" [errorCorrectionLevel]="'M'"
             [width]="75" [value]="value()" woa-activatable (onActivate)="expand($event)"></woa-qr-code>
